export default __webpack_public_path__ + "static/210521_妲絲刷關活動熱更預告_jp-07449cef6c1f1849f39669c48029f735.png";